import moment from "moment";

export default class DateValidation {

  static isOutsideRange(day) {
    return day.isBefore(moment(), 'day');
  }

  static isOutsideMaxSchedulingRange(startDate, endDate, maxSchedulingRange) {
    return endDate.diff(startDate, 'days') >= maxSchedulingRange;
  }


  static validDate(date, type) {
    return date.isValid() ? "" : "Invalid " + type + " Date.\n\r";
  }

  static withinRange(date, type) {
    return DateValidation.isOutsideRange(date) ? type + " is outside of the available date range\n\r" : "";
  }

  static startBeforeEnd(startDate, endDate) {
    return startDate.isAfter(endDate) ? "Start Date must be before End Date\n\r" : "";
  }

  static rangeTooLarge(startDate, endDate, maxSchedulingRange) {
    return DateValidation.isOutsideMaxSchedulingRange(startDate, endDate, maxSchedulingRange) ? "The Selected Date Range is too" +
      " Large\n\r" : "";
  }

}
